var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaturlegeplads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.548,5.242h0a.285.285,0,0,0-.024-.569h0l-1.09.048L8.15,4.348,7.075,4.33,6.033,4.6l-.514-.791a.284.284,0,1,0-.476.31l.62.953a.288.288,0,0,0,.293.125l.9.012L6.219,7.9h0v0a.057.057,0,0,0,.056.056h.455v.326l-.5,1.077a.369.369,0,1,0,.67.311l.528-1.133,0-.009a.357.357,0,0,0,.04-.163V7.953h.113v1.66a.37.37,0,1,0,.739,0V7.953h.459A.057.057,0,0,0,8.841,7.9v0h0L8.285,5.234l1.038.046h0a.3.3,0,0,0,.091.012Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.7,
    y: 11.049,
    width: 1.758,
    height: 2.38,
    rx: 0.273,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.03,
    y: 10.176,
    width: 1.758,
    height: 3.254,
    rx: 0.273,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.384,
    y: 11.671,
    width: 1.758,
    height: 1.758,
    rx: 0.273,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.383,3.185c.35-.354.573-.5.7-.468a.819.819,0,0,0-.337.652.833.833,0,0,0,1.666,0,.811.811,0,0,0-.189-.506c.129-.036.329.144.625.59.324.487.933.03.933.03-.464.04-.211-.638-.742-1.047-.47-.361-.882.154-.971.277A.759.759,0,0,0,7.285,2.6c-.076-.159-.378-.7-.893-.445-.6.3-.482,1.013-.93.885C5.462,3.036,5.972,3.6,6.383,3.185Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaturlegeplads);
export default __webpack_public_path__ + "static/media/NATURLEGEPLADS.7ed8d7ff84e1177122fe8154ad3b5b40.svg";
export { ForwardRef as ReactComponent };